module.exports = "https://web-assets.ifttt.com/packs/media/docs/field_visibility-c83d5d0d.png";